<div>
  <mat-slide-toggle
    [checked]="element.connected"
    (change)="updateConnectedStatus($event.checked)"
    [color]="'primary'"
  ></mat-slide-toggle>
</div>
